import React from 'react';
import '../../../../static/styles/apiguide.scss';
import '../../../../static/styles/dashboard.scss';

export default class UpdateTourProductV2 extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const col_number_8 = 8;
        const level1 = 5;
        const level2 = 4;
        const level3 = 3;
        const level4 = 2;
        const level5 = 1;

        return (
            <div className="mb0 mt40" id="create-tour-product">
                {/*<h3>4. 하나의 여행상품 생성 API</h3>*/}
                <h3>상품 수정</h3>

                <div className="blog-post-meta">
                    <span className="s-post">쿠팡에서 판매할 해외 패키지/항공 상품을 수정하는 API 입니다. <br/>수정 요청 후 반드시 조회 API로 수정 여부를 확인 해 주시기 바랍니다.</span>
                    <h3 className="request-method">
                        <span className="label label-success">PUT</span>
                    </h3>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>Path</th>
                            <th colSpan={3}>Example Endpoint</th>
                        </tr>
                        <tr>
                            <td>/v2/marketplace/update/{`{type}`}/tour/product</td>
                            <td colSpan={3}>https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v2/marketplace/update/overseas/tour/product
                            </td>
                        </tr>
                        <tr>
                            <th colSpan="4" className="bold">Path Segment Parameter</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>type</td>
                            <td>O</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <td>분류 카테고리</td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Value</th>
                                        <th>Type</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>overseas</td>
                                        <td>String</td>
                                        <td>해외</td>
                                    </tr>
                                    <tr>
                                        <td>domestic</td>
                                        <td>String</td>
                                        <td>국내</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt10">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                            <tr>
                                <th colSpan={col_number_8} className="bold">Request Header</th>
                            </tr>
                            <tr>
                                <th colSpan={level1}>Name</th>
                                <th>Required</th>
                                <th>Type</th>
                                <th>Description</th>
                            </tr>
                            <tr>
                                <td colSpan={level1}>Request-Vendor-Id</td>
                                <td>O</td>
                                <td>String</td>
                                <td>벤더 아이디</td>
                            </tr>
                            <tr>
                                <th colSpan={col_number_8} className="bold">Body Parameter</th>
                            </tr>
                            <tr>
                                <th colSpan={level1}>Name</th>
                                <th>Required</th>
                                <th>Type</th>
                                <th>Description</th>
                            </tr>
                            <tr>
                                <td colSpan={level1}>travelProductId</td>
                                <td>O</td>
                                <td>Long</td>
                                <td>쿠팡 상품 아이디</td>
                            </tr>
                            <tr>
                                <td colSpan={level1}>propertyId</td>
                                <td>O</td>
                                <td>String</td>
                                <td>셀러에서 상품을 관리하기 위해 사용한 아이디</td>
                            </tr>
                            <tr>
                                <td colSpan={level1}>title</td>
                                <td>O</td>
                                <td>String</td>
                                <td>여행상품명 (최대 문자열 길이는 50자 입니다)</td>
                            </tr>
                            <tr>
                                <td colSpan={level1}>introduction</td>
                                <td>X</td>
                                <td>String</td>
                                <td>여행상품소개</td>
                            </tr>
                            <tr>
                                <td colSpan={level1}>searchTags</td>
                                <td>O</td>
                                <td>Array</td>
                                <td>서치태그 리스트 (각 서치태그 최대 문자열 길이는 10자 입니다)</td>
                            </tr>
                            <tr>
                                <td colSpan={level1}>destination</td>
                                <td>O</td>
                                <td>String</td>
                                <td>상품에 표시할 도착 지역 키워드 (각 키워드 최대 문자열 길이는 10자 입니다)</td>
                            </tr>
                            <tr>
                                <td colSpan={level1}>displayCategoryCode</td>
                                <td>O</td>
                                <td>Integer</td>
                                <td>상품의 노출 카테고리. Example: 106774 (생성 후 변경불가 항목 입니다)</td>
                            </tr>
                            <tr>
                                <td colSpan={level1}>airportCode</td>
                                <td>X</td>
                                <td>String</td>
                                <td>IATA 공항 코드. Example: SHA</td>
                            </tr>
                            <tr>
                                <td colSpan={level1}>representativeImages</td>
                                <td>O</td>
                                <td>Array</td>
                                <td>복수 대표 이미지 URL</td>
                            </tr>
                            <tr>
                                <td colSpan={level1}>composition</td>
                                <td>O</td>
                                <td>String</td>
                                <td>
                                    <table className="table table-striped">
                                        <tbody>
                                            <tr>
                                                <td>상품 구성 요소</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <th>Optional Value</th>
                                                <th>Description</th>
                                            </tr>
                                            <tr>
                                                <td>FUEL_SURCHARGE_INCLUDED</td>
                                                <td>유류할증료 포함</td>
                                            </tr>
                                            <tr>
                                                <td>FUEL_SURCHARGE_TAX_EXCLUDED</td>
                                                <td>유류할증료+세금불포함</td>
                                            </tr>
                                            <tr>
                                                <td>FUEL_SURCHARGE_NOT_APPLICABLE</td>
                                                <td>해당없음(유류할증료)</td>
                                            </tr>
                                            <tr>
                                                <td>SHOPPING_INCLUDE</td>
                                                <td>쇼핑 포함</td>
                                            </tr>
                                            <tr>
                                                <td>SHOPPING_EXCLUDE</td>
                                                <td>쇼핑 불포함</td>
                                            </tr>
                                            <tr>
                                                <td>ADDITIONAL_EXPENSE_INCLUDE</td>
                                                <td>추가경비 포함</td>
                                            </tr>
                                            <tr>
                                                <td>ADDITIONAL_EXPENSE_EXCLUDE</td>
                                                <td>추가경비 불포함</td>
                                            </tr>
                                            <tr>
                                                <td>FREE_SCHEDULE_INCLUDE</td>
                                                <td>자유일정 포함</td>
                                            </tr>
                                            <tr>
                                                <td>FREE_SCHEDULE_EXCLUDE</td>
                                                <td>자유일정 불포함</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={level1}>saleStatus</td>
                                <td>X</td>
                                <td>String</td>
                                <td>
                                    <table className="table table-striped">
                                        <tbody>
                                            <tr>
                                                <td>상품 판매 상태. 기본값: ON_SALE</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <th>Optional Value</th>
                                                <th>Description</th>
                                            </tr>
                                            <tr>
                                                <td>ON_SALE</td>
                                                <td>판매중</td>
                                            </tr>
                                            <tr>
                                                <td>SUSPENDED</td>
                                                <td>판매일시중지</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={level1}>items</td>
                                <td>O</td>
                                <td>Array</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td colSpan={level2}>travelItemId</td>
                                <td>X</td>
                                <td>Long</td>
                                <td>쿠팡 상품 아이템 아이디. (travelItemId가 travelProduct 하위에 존재하지 않는 경우는 Item 추가,
                                    존재하는 경우는 Item 정보 수정으로 진행됩니다.)</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td colSpan={level2}>propertyItemId</td>
                                <td>O</td>
                                <td>String</td>
                                <td>셀러에서 상품을 관리하기 위해 사용한 아이템 단위 아이디</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td colSpan={level2}>title</td>
                                <td>O</td>
                                <td>String</td>
                                <td>여행아이템명 (최대 문자열 길이는 50자 입니다)</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td colSpan={level2}>departure</td>
                                <td>X</td>
                                <td>Object</td>
                                <td><table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <td>출발 항공편 정보</td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Name</th>
                                        <th>Type</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>takeOffDate</td>
                                        <td>String (format : yyyy-MM-dd HH:mm:ss)</td>
                                        <td>이륙시간</td>
                                    </tr>
                                    <tr>
                                        <td>landingDate</td>
                                        <td>String (format : yyyy-MM-dd HH:mm:ss)</td>
                                        <td>착륙시간</td>
                                    </tr>
                                    <tr>
                                        <td>flight</td>
                                        <td>String</td>
                                        <td>항공편 (예 : OZ757)</td>
                                    </tr>
                                    </tbody>
                                </table></td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td colSpan={level2}>arrival</td>
                                <td>X</td>
                                <td>Object</td>
                                <td><table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <td>도착 항공편 정보</td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Name</th>
                                        <th>Type</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>takeOffDate</td>
                                        <td>String (format : yyyy-MM-dd HH:mm:ss)</td>
                                        <td>이륙시간</td>
                                    </tr>
                                    <tr>
                                        <td>landingDate</td>
                                        <td>String (format : yyyy-MM-dd HH:mm:ss)</td>
                                        <td>착륙시간</td>
                                    </tr>
                                    <tr>
                                        <td>flight</td>
                                        <td>String</td>
                                        <td>항공편 (예 : OZ757)</td>
                                    </tr>
                                    </tbody>
                                </table></td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td colSpan={level2}>hasChildRate</td>
                                <td>O</td>
                                <td>Boolean</td>
                                {/*아동, 유아 요금카테고리 유무 (성인은 기본 포함)*/}
                                <td>판매상태 설정 / 판매중 : TRUE, 판매중지 : FALSE (Default: TRUE)</td>
                            </tr>

                            <tr>
                                <td>&nbsp;</td>
                                <td colSpan={level2}>notices</td>
                                <td>O</td>
                                <td>Object</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td colSpan={level3}>usage</td>
                                <td>O</td>
                                <td>String</td>
                                <td>유의사항</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td colSpan={level3}>inclusion</td>
                                <td>O</td>
                                <td>String</td>
                                <td>포함사항</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td colSpan={level3}>exclusion</td>
                                <td>O</td>
                                <td>String</td>
                                <td>불포함사항</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td colSpan={level3}>reservation</td>
                                <td>O</td>
                                <td>String</td>
                                <td>예약안내</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td colSpan={level3}>customerCenter</td>
                                <td>O</td>
                                <td>String</td>
                                <td>고객센터 운영시간. Example: 고객센터 문의시간: 1644-2888, 평일 09:30~17:30 (단, 토/일, 공휴일은 휴무)</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td colSpan={level2}>duration</td>
                                <td>O</td>
                                <td>Object</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td colSpan={level3}>days</td>
                                <td>O</td>
                                <td>Integer</td>
                                <td>여정 일 수	</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td colSpan={level3}>nights</td>
                                <td>O</td>
                                <td>Integer</td>
                                <td>여정 숙박 수</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td colSpan={level2}>itinerary</td>
                                <td>O</td>
                                <td>Array</td>
                                <td>일정</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td colSpan={level3}>days</td>
                                <td>O</td>
                                <td>Integer</td>
                                <td>일정 차수. Exmaple: 1, 2</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td colSpan={level3}>order</td>
                                <td>O</td>
                                <td>Integer</td>
                                <td>정렬 순서</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td colSpan={level3}>courseName</td>
                                <td>O</td>
                                <td>String</td>
                                <td>일정 제목</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td colSpan={level3}>location</td>
                                <td>O</td>
                                <td>String</td>
                                <td>위치안내정보</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td colSpan={level3}>mealName</td>
                                <td>O</td>
                                <td>String</td>
                                <td>식사명</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td colSpan={level3}>hotelName</td>
                                <td>O</td>
                                <td>String</td>
                                <td>숙소명</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td colSpan={level3}>description</td>
                                <td>O</td>
                                <td>String</td>
                                <td>일정설명</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td colSpan={level3}>representativeImage</td>
                                <td>O</td>
                                <td>String</td>
                                <td>일정 이미지 URL</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title"></h3>
                            <a data-toggle="collapse" href = "#createTourDto">Request Body</a>
                        </div>
                        <div id = "createTourDto" className = "panel-collapse collapse">
                            <div id = "createTourDto" className="panel-body">
                    <pre className="ty01">
                        {`
{
  "tourProductDtoList": [
    {
      "displayCategoryCode": 108804,
      "propertyId": "seller-product-id",
      "title": "[인천/김포출발] 상해+항주+수향마을 패키지",
      "items": [
        {
          "propertyItemId": "seller-item-id-1",
          "title": "상해/항주/주가각 1일",
          "departure":{
              "takeOffDate":"2020-03-16 09:30:00",
              "landingDate":"2020-03-16 13:30:00",
              "flight":"KE982"
           },
           "arrival":{
              "takeOffDate":"2020-03-25 18:30:00",
              "landingDate":"2020-03-25 22:30:00",
              "flight":"KE982"
           },
          "duration": {
            "days": 3,
            "nights": 4
          },
          "itinerary": [
            {
              "courseName": "항공스케쥴",
              "days": 1,
              "order": 1,
              "descriptions": "[KE893] 08:35 인천 상해 향발 (약 02시간 10분 소요) 09:45 상해 도착",
              "location": ""
            },
            {
              "courseName": "[관광] 상해",
              "days": 1,
              "order": 2,
              "descriptions": "도시개요 - 소개 : 상하이는 중국 양쯔강 어귀에 있는 상공업 도시로 정부 직할시이다",
              "location": "",
              "representativeImage": "http://img.test-tour.com/test.jpg"
            },
            {
              "courseName": "상해-항주 이동 (약3시간 소요)",
              "days": 1,
              "order": 3,
              "descriptions": "",
              "location": "",
              "representativeImage": "http://img.test-tour.com/test.jpg"
            },
            {
              "courseName": "[관광] 항주",
              "days": 1,
              "order": 4,
              "descriptions": "오래된 옛 찻집들로 유명한 곳"
            }
          ],
          "notices": {
            "usage": "본 상품은 단체관광을 목적으로 하는 패키지여행으로, 관광에 참여하지 않고 개별적인 활동을 원하시는 분들은 자유여행 상품으로 예약해 주시기 바랍니다.",
            "inclusion": "왕복 항공권 포함",
            "exclusion": "1인당 전일정 가이드",
            "reservation": "담당자가 예약확정여부를 문자로 알려드립니다.",
            "customerCenter": "고객센터 문의시간: 1644-2888, 평일 09:30~17:30 (단, 토/일, 공휴일은 휴무)"
          }
        },
        {
          "propertyItemId": "seller-item-id-2",
          "title": "상해/항주/주가각 2일",
          "departure":{
              "takeOffDate":"2020-03-16 09:30:00",
              "landingDate":"2020-03-16 13:30:00",
              "flight":"KE982"
           },
           "arrival":{
              "takeOffDate":"2020-03-25 18:30:00",
              "landingDate":"2020-03-25 22:30:00",
              "flight":"KE982"
           },
          "duration": {
            "days": 3,
            "nights": 4
          },
          "itinerary": [
            {
              "courseName": "항공스케쥴",
              "days": 1,
              "order": 1,
              "descriptions": "[KE893] 08:35 인천 상해 향발 (약 02시간 10분 소요) 09:45 상해 도착",
              "location": ""
            },
            {
              "courseName": "[관광] 상해",
              "days": 1,
              "order": 2,
              "descriptions": "도시개요 - 소개 : 상하이는 중국 양쯔강 어귀에 있는 상공업 도시로 정부 직할시이다",
              "location": "",
              "representativeImage": "http://img.test-tour.com/test.jpg"
            },
            {
              "courseName": "상해-항주 이동 (약3시간 소요)",
              "days": 1,
              "order": 3,
              "descriptions": "",
              "location": "",
              "representativeImage": "http://img.test-tour.com/test.jpg"
            },
            {
              "courseName": "[관광] 항주",
              "days": 1,
              "order": 4,
              "descriptions": "오래된 옛 찻집들로 유명한 곳"
            }
          ],
          "notices": {
            "usage": "본 상품은 단체관광을 목적으로 하는 패키지여행으로, 관광에 참여하지 않고 개별적인 활동을 원하시는 분들은 자유여행 상품으로 예약해 주시기 바랍니다.",
            "inclusion": "왕복 항공권 포함",
            "exclusion": "1인당 전일정 가이드",
            "reservation": "담당자가 예약확정여부를 문자로 알려드립니다.",
            "customerCenter": "고객센터 문의시간: 1644-2888, 평일 09:30~17:30 (단, 토/일, 공휴일은 휴무)"
          }
        }
      ],
      "searchTags": [
        "상해",
        "항주",
        "수향마을"
      ],
      "destination": "상하이",
      "representativeImages": [
        "http://img.test-tour.com/test.jpg"
      ],
      "composition": [
        "FUEL_SURCHARGE_INCLUDED",
        "SHOPPING_INCLUDE",
        "ADDITIONAL_EXPENSE_INCLUDE",
        "FREE_SCHEDULE_INCLUDE"
      ],
      "airportCode": "SHA",
      "saleStatus": "ON_SALE",
      "introduction": "고품으로 알찬 상해여행특전1. NO팁 NO옵션특전2. 전 일정VIP리무진 탑승특전3. 송성가무쇼VIP /황포강유람선/ 전신마사지 포함특전4. 차별화된 특식 동파육,사천요리,삼겹살무제한 제공"
    }
  ]
}
                        `}
                    </pre>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>productCreateResponseDto</td>
                            <td>Object</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>travelProductId</td>
                            <td>Long</td>
                            <td>여행상품 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>sellerProductId</td>
                            <td>String</td>
                            <td>셀러에서 상품을 관리하기 위해 사용한 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>itemCreateResponse</td>
                            <td>List{'<itemCreateResponse>'}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>sellerTravelItemId</td>
                            <td>String</td>
                            <td>셀러에서 상품을 관리하기 위해 사용한 아이템 단위 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>name</td>
                            <td>String</td>
                            <td>여행 아이템명</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>travelItemId</td>
                            <td>String</td>
                            <td>쿠팡 상품 아이템 아이디</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">응답값 예시</h3>
                        </div>
                        <div className="panel-body">
                    <pre className="ty01">
                        {`
{
  "code": 200,
  "message": "SUCCESS",
  "data": [
    {
      "travelProductId": 542240730693763100,
      "sellerProductId": "seller-product-id",
      "itemCreateResponse": [
        {
          "name": "상해/항주/주가각 1일",
          "travelItemId": 542240730999947260,
          "sellerTravelItemId": "seller-item-id-1"
        },
        {
          "name": "상해/항주/주가각 2일",
          "travelItemId": 542240731289354240,
          "sellerTravelItemId": "seller-item-id-2"
        }
      ]
    }
  ]
}
                        `}
                    </pre>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>HTTP CODE</th>
                            <th>message</th>
                            <th>설명</th>
                        </tr>
                        <tr>
                            <td>400</td>
                            <td>Bad request</td>
                            <td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다
                                <div>
                                    <a data-toggle="collapse" href="#errorMessagesforCreateProduct">400 Error Messages</a>
                                </div>
                                <div id="errorMessagesforCreateProduct" className="panel-collapse collapse">
                                    <div className="panel-body">
                                        <li>이넘 타입 {'${enumClazz.getSimpleName()}'}에 대한 무효 문자열 값</li>
                                        <li>무효 display category code   </li>
                                        <li>images가 비어있을 수 없음</li>
                                        <li>복제 된 이미지 경로</li>
                                        <li>대표 이미지 단 한장만 허용 가능</li>
                                        <li>국내 여행에 대한 locations가 비어있으면 안됨 </li>
                                        <li>landNumberAddress중 하나와 roadNameAddress를 제공해야함</li>
                                        <li>무효 seqs  </li>
                                        <li>format이 IMAGE가 아닌 경우 content를 반드시 제공해야함</li>
                                        <li>format이 IMAGE인 경우 sellerUrl를 반드시 제공해야함</li>
                                        <li>title을 반드시 제공해야함</li>
                                        <li>travelType 및 productDetailType가 일치하지 않음</li>
                                        <li>무효 theme </li>
                                        <li>instantBooking이 false인 경우 estimatedBookingDuration이0보다 크고 72보다 작거나 같아야됨</li>
                                        <li>연락처에 대표 전화 번호가 하나 있어야함 </li>
                                        <li>무효 tour feature id </li>
                                        <li>무효 tour feature value</li>
                                        <li>무효 tour item feature id</li>
                                        <li>무효 tour item feature value  </li>
                                        <li>무효 일자/시간 포맷, 포맷이 {'{pattern}'}이어야함</li>
                                        <li>판매 시작일은 판매 종료일보다 늦지 않아야함</li>
                                        <li>중복 취소 환불율refund rates</li>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>401</td>
                            <td>Unauthorized Error</td>
                            <td>잘못된 인증 정보</td>
                        </tr>
                        <tr>
                            <td>403</td>
                            <td>Forbidden Error</td>
                            <td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
                        </tr>
                        <tr>
                            <td>410</td>
                            <td>The resource has been permanently deleted</td>
                            <td>리소스가 삭제되었을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>412</td>
                            <td>Precondition failed</td>
                            <td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>429</td>
                            <td>Too many requests</td>
                            <td>요청이 많을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>504</td>
                            <td>API Gateway response timeout</td>
                            <td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>521</td>
                            <td>API provider server has error</td>
                            <td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>524</td>
                            <td>API provider to API gateway connection response timeout</td>
                            <td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TourAPIContent/V2/ProductAPI/UpdateTourProductV2.jsx